import React from 'react';
import { OrderSide } from 'communication/types/order/OrderSide';
import styleConstants from 'widgets/fillsGraph/variables.module.scss';
import { getColourForSide } from 'utils/css/cssUtils';

interface FillNodeProps {
    side?: OrderSide;
}

export default function FillNode({ side }: FillNodeProps) {
    const fill = getColourForSide(side);
    return (
        <svg
            width="12px"
            height="12px"
            viewBox="0 0 12 12"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                fill={fill}
                stroke={styleConstants.nodeStrokeColour}
                strokeWidth="1"
                id="fill-node"
                cx="6"
                cy="6"
                r="5"
            />
        </svg>
    );
}
